import { Component, Input } from '@angular/core';
import { AddCreditRequestResponse } from '@lsq-frontend/remote-services/enterprise/common';

@Component({
    selector: 'credit-status-card',
    template: `
        <search-customer-card [name]="customer.debtorName" [address]="customer.debtorAddress">
            <div class="customer-card-child-container">
                <span class="text-right">
                    <h6>Requested Credit Limit</h6>
                    <h3>{{ customer.requestedAmount | currency }}</h3>
                </span>
                <span class="spacer-item"></span>
                <span class="text-right">
                    <h6>Approved Credit Limit</h6>
                    <h3>{{ customer.approvedAmount || 0 | currency }}</h3>
                </span>
            </div>
        </search-customer-card>
    `,
    styleUrls: ['./credit-status-card.component.scss']
})
export class CreditStatusCardComponent {
    @Input() public customer: AddCreditRequestResponse;
}
